__turbopack_context__.v({
  "active": "t0_rFa_active",
  "autocomplete-root": "t0_rFa_autocomplete-root",
  "box-result": "t0_rFa_box-result",
  "box-result-search": "t0_rFa_box-result-search",
  "box-topic": "t0_rFa_box-topic",
  "button-wrapper": "t0_rFa_button-wrapper",
  "col-img": "t0_rFa_col-img",
  "content-desc": "t0_rFa_content-desc",
  "faq-group": "t0_rFa_faq-group",
  "faq-group-color": "t0_rFa_faq-group-color",
  "faq-group-title": "t0_rFa_faq-group-title",
  "faq-topics": "t0_rFa_faq-topics",
  "faq-topics-col": "t0_rFa_faq-topics-col",
  "faq-topics-row": "t0_rFa_faq-topics-row",
  "fav-divider": "t0_rFa_fav-divider",
  "fav-question-group": "t0_rFa_fav-question-group",
  "fav-question-row": "t0_rFa_fav-question-row",
  "highlight-text": "t0_rFa_highlight-text",
  "page-body-wrap": "t0_rFa_page-body-wrap",
  "page-header": "t0_rFa_page-header",
  "page-header-wrap": "t0_rFa_page-header-wrap",
  "row-suggest": "t0_rFa_row-suggest",
  "search-btn": "t0_rFa_search-btn",
  "section-autocomplete": "t0_rFa_section-autocomplete",
  "show-divider": "t0_rFa_show-divider",
  "subtitle-text": "t0_rFa_subtitle-text",
  "title-fav-question": "t0_rFa_title-fav-question",
  "title-text": "t0_rFa_title-text",
  "topic-description": "t0_rFa_topic-description",
  "topic-logo": "t0_rFa_topic-logo",
  "topic-title": "t0_rFa_topic-title",
  "wrap-icon-arrow": "t0_rFa_wrap-icon-arrow",
});
